export default __webpack_public_path__ + "static/media/(27).c7b177e3.jpeg";